<template>
  <div>
    <b-input-group class="filter-group">
      <b-input-group-prepend is-text>
        <font-awesome-icon icon="search" />
      </b-input-group-prepend>
      <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
      <b-input-group-append>
        <b-button @click="filter = null">Clear</b-button>
      </b-input-group-append>

      <b-button class="new-team-button" :to="{name: 'translationalTeamAdd'}" variant="primary">
        <font-awesome-icon icon="plus" /> New Translational Team
      </b-button>
    </b-input-group>

    <b-table striped
              hover
              :items="translationalTeams"
              :fields="fields"
              :per-page="perPage"
              :current-page="currentPage"
              :filter="filter"
              @filtered="onFiltered"
              responsive
              small>
      <template slot="translationalTeamSites" slot-scope="data">
        {{ (data.item.translationalTeamSites && data.item.translationalTeamSites.length) | trueOrFalse }}
      </template>
      <template slot="startDate" slot-scope="data">
        {{ data.item.startDate | formatDate }}
      </template>
      <template slot="endDate" slot-scope="data">
        {{ data.item.endDate | formatDate }}
      </template>
      <template slot="details" slot-scope="data">
        <router-link :to="{ name: 'translationalTeam', params: {translationalTeamId: data.item.translationalTeamId } }">Details</router-link>
      </template>
    </b-table>

    <b-pagination :total-rows="totalRows" v-model="currentPage" :per-page="perPage" align="right" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      fields: [
        { key: "name", sortable: true },
        { key: "translationalTeamSites", label: "Has Sites", sortable: true },
        {
          key: "approvedStudentCount",
          label: "Approved Students",
          sortable: true
        },
        {
          key: "pendingStudentCount",
          label: "Pending Students",
          sortable: true
        },
        { key: "startDate", sortable: true },
        { key: "endDate", sortable: true },
        { key: "details" }
      ],
      currentPage: 1,
      perPage: 20,
      filter: null,
      totalRows: 0
    };
  },

  props: {
    translationalTeams: {
      type: Array,
      required: true
    }
  },

  watch: {
    translationalTeams: function() {
      this.totalRows = this.translationalTeams.length;
    }
  },

  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    }
  }
};
</script>

<style scoped>
.filter-group {
  margin: 10px 0 15px 0;
  max-width: 600px;
}

.new-team-button {
  margin-left: 10px;
}

.btn-primary {
  background-color: #8c1d40;
  border-color: #70112f;
}

.btn-primary:hover {
  background-color: #a02048;
}
</style>
